import catalogue from "./catalogue";

const api = {
  catalogue,
};

export default api;
